module.exports = require('./helpers/bundle-url').getBundleURL('jgZB5') + "../enable2k.4cc70525.txt";